import React, { useState, useEffect } from 'react';
import styled from "styled-components";
import Banner from '../../Components/Banner';
import LicenceLinkForm from './LicenceLinkForm';
import { NamedDriverType } from '../../Components/Types';
import { useNavigate, useParams } from 'react-router';
import ReactGA from "react-ga4";
import { useMsal } from '@azure/msal-react';
import { NamedDriverAPI } from 'API/NamedDriverAPI';
import ErrorMessage from 'Components/ErrorMessage';

const PageContainer = styled.div`
    padding: 1em;
    display:flex;
    justify-content:center;
    @media (min-width: 1400px) {
        padding: 3em;
    }
`;
const FormsContainer = styled.div`
    width: 80%;
    @media (min-width: 1400px) {
        width: 60%;
    }
`;
function LicenceCheckPage() {
    const [noBooking, setNoBooking] = useState<boolean>(false);
    const { bookingId } = useParams<{ bookingId: string}>();
    const navigate = useNavigate();
    const [namedDrivers, setNamedDrivers] = useState<NamedDriverType[]>([]);
    const { instance } = useMsal();
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    
    useEffect(() => {
        if (bookingId) {
            const getNamedDrivers = async () => {
                try {
                    const response = await NamedDriverAPI.get(instance, parseInt(bookingId));
                    if (response.length > 1) {
                        if (response.length == 1 && response[0].mandate_status > 2) {
                            navigate("/MyAccount/Bookings");
                        }
                        if (response.length == 2) {
                            const mainDriver: NamedDriverType = response.find((md: NamedDriverType) => md.main_driver);
                            const additionalDriver: NamedDriverType = response.find((md: NamedDriverType) => !md.main_driver);
                            response[0] = mainDriver;
                            response[1] = additionalDriver;
                            if (mainDriver.mandate_status && additionalDriver.mandate_status) {
                                if (mainDriver.mandate_status > 2 && additionalDriver.mandate_status > 2) {
                                    navigate("/MyAccount/Bookings");
                                }
                            }
                        }
                        setNamedDrivers(response)
                    }
                    setNamedDrivers(response);
                }
                catch {
                    setNoBooking(true)
                }
            }
            getNamedDrivers();
        }

    }, []);

    return (
        <>
            <Banner mainText="Licence Check" />
            <PageContainer>
                <FormsContainer>
                    {noBooking ?
                        <ErrorMessage /> :
                        namedDrivers.map((driver: NamedDriverType, i) => {
                            return (
                                <LicenceLinkForm key={i} driver={driver} />
                            );
                        })
                    }
                </FormsContainer>
            </PageContainer>
        </>
    );
}
export default LicenceCheckPage;
